import { fetchV2 } from "../../lib/api-v2";

import type { ClonedVoice, OrganizationVoiceInventory } from "./types";

export const listClones = () =>
  fetchV2<{ voices: ClonedVoice[] }>("/voice/clones").then((data) => data.voices ?? []);

export interface CloneInput {
  name: string;
  language: string;
  gender: string;
  clip: Blob;
}

export function createClone({ name, language, gender, clip }: CloneInput) {
  const form = new FormData();
  form.append("name", name);
  form.append("language", language);
  form.append("gender", gender);
  // The server refuses the clone without this; the checkbox is not decoration.
  form.append("consent_accepted", "true");
  form.append("clip", clip, `${name}.wav`);
  return fetchV2<ClonedVoice>("/voice/clones", { method: "POST", body: form });
}

export function recloneVoice(voiceId: string, clip: Blob) {
  const form = new FormData();
  form.append("clip", clip, "sample.wav");
  return fetchV2<ClonedVoice>(`/voice/clones/${voiceId}`, { method: "PUT", body: form });
}

export const deleteClone = (voiceId: string) =>
  fetchV2<{ status: string }>(`/voice/clones/${voiceId}`, { method: "DELETE" });

export const getSampleUrl = (voiceId: string) =>
  fetchV2<{ url: string }>(`/voice/clones/${voiceId}/sample`).then((data) => data.url);

export const getOrganizationVoices = (orgId: string) =>
  fetchV2<OrganizationVoiceInventory>(`/organizations/${orgId}/voices`);

export const setMemberVoiceAccess = (orgId: string, userId: string, allowedVoices: string[]) =>
  fetchV2<{ user_id: string; allowed_voices: string[] }>(
    `/organizations/${orgId}/members/${userId}/voices`,
    { method: "PATCH", body: JSON.stringify({ allowed_voices: allowedVoices }) },
  );
